import React from 'react';
import PropTypes from 'prop-types';
import ContentEditable from 'react-contenteditable';
import TextareaAutosize from 'react-autosize-textarea';
import './ContentEditableComponent.scss';

function Title({ title, showError, requiredText }) {
  return (
    <div className={`editable-header ${requiredText && 'add-spacing'}`}>
      {title && <span className="title">{title}</span>}
      <span className={`header-required${showError ? ' with-error' : ''}`}>
        {requiredText || '*'}
      </span>
    </div>
  );
}

Title.propTypes = {
  title: PropTypes.string,
  requiredText: PropTypes.string,
  showError: PropTypes.bool,
};

Title.defaultProps = {
  title: null,
  showError: null,
  requiredText: null,
};

function Description({ description }) {
  return description && <div className="description">{description}</div>;
}

// ContentEditableComponent ContentEditor
function ContentEditor({
  value,
  handleOnChange,
  className,
  withBulletPoints,
  showError,
  placeholder,
  required,
  rehireOrProposalRequest,
}) {
  if (withBulletPoints) {
    return (
      <ContentEditable
        html={value}
        disabled={false}
        onChange={(event) => handleOnChange(event)}
        tagName="ul"
        className={`${className} with-bullet-points ${showError && !rehireOrProposalRequest && 'with-error'}`}
      />
    );
  }

  return (
    <TextareaAutosize
      className={`${className} textarea ${showError && 'with-error'}`}
      placeholder={placeholder}
      value={value}
      required={required}
      onChange={(event) => handleOnChange(event.target.value)}
    />
  );
}

ContentEditor.propTypes = {
  withBulletPoints: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  handleOnChange: PropTypes.func,
  showError: PropTypes.bool,
  rehireOrProposalRequest: PropTypes.bool,

};

ContentEditor.defaultProps = {
  withBulletPoints: false,
  required: false,
  placeholder: null,
  className: '',
  showError: null,
  value: '',
  handleOnChange: () => {},
  rehireOrProposalRequest: false,
};

// ContentEditableComponent Footer
function Footer({
  errorMessage,
  showClearSuggestion,
  handleClearSuggestions,
  suggestionText,
}) {
  return (
    <div className="footer">
      {errorMessage && <span className="error">{errorMessage}</span>}
      <div>
        {(showClearSuggestion && suggestionText)
        && <span className="suggestion-text">{suggestionText}</span>}
        {showClearSuggestion && (
        <a role="button" tabIndex={0} onClick={handleClearSuggestions}>
          Clear Suggestions
        </a>
        )}
      </div>
    </div>
  );
}

Footer.propTypes = {
  errorMessage: PropTypes.string,
  handleClearSuggestions: PropTypes.func,
  showClearSuggestion: PropTypes.bool,
  suggestionText: PropTypes.string,
};

Footer.defaultProps = {
  errorMessage: null,
  handleClearSuggestions: () => {},
  showClearSuggestion: false,
  suggestionText: null,
};

function ContentEditableComponent({
  title,
  description,
  withBulletPoints,
  placeholder,
  required,
  showError,
  handleOnChange,
  value,
  handleClearSuggestions,
  showClearSuggestion,
  className,
  errorMessage,
  requiredText,
  rehireOrProposalRequest,
  suggestionText,
}) {
  return (
    <div className="editable-container">
      <Title
        title={title}
        showError={showError}
        requiredText={requiredText}
      />
      <Description description={description} />
      <ContentEditor
        value={value}
        handleOnChange={handleOnChange}
        className={className}
        withBulletPoints={withBulletPoints}
        placeholder={placeholder}
        showError={showError}
        required={required}
        rehireOrProposalRequest={rehireOrProposalRequest}
      />
      <Footer
        errorMessage={errorMessage}
        showClearSuggestion={showClearSuggestion}
        handleClearSuggestions={handleClearSuggestions}
        suggestionText={suggestionText}
      />
    </div>
  );
}

ContentEditableComponent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  withBulletPoints: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string,
  errorMessage: PropTypes.string,
  handleOnChange: PropTypes.func,
  handleClearSuggestions: PropTypes.func,
  showClearSuggestion: PropTypes.bool,
  requiredText: PropTypes.string,
  showError: PropTypes.bool,
  rehireOrProposalRequest: PropTypes.bool,
  suggestionText: PropTypes.string,
};

ContentEditableComponent.defaultProps = {
  title: null,
  description: null,
  withBulletPoints: false,
  required: false,
  placeholder: null,
  className: '',
  showError: null,
  errorMessage: null,
  value: '',
  handleOnChange: () => {},
  handleClearSuggestions: () => {},
  showClearSuggestion: false,
  requiredText: null,
  rehireOrProposalRequest: false,
  suggestionText: null,
};

export default ContentEditableComponent;
